import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Join from "./pages/Join/Join";
import OfficeJoin from "./pages/Join/OfficeJoin";
import UserJoin from "./pages/Join/UserJoin";
import UserJoinPhysical from "./pages/Join/UserJoinPhysical";
import FindId from "./pages/Join/FindId";
import FindPassword from "./pages/Join/FindPassword";
import JoinAgree from "./pages/Join/JoinAgree";
import JoinAgreePop from "./pages/Join/JoinAgreePop";

import Reservation from "./pages/Reservation";
import ReservationStep from "./pages/reservation/ReservationStep";
import SetFinishDetail from "./pages/reservation/SetFinishDetail";
import SetPayValidation from "./pages/reservation/SetPayValidation";

import ConsultationReservation from "./pages/ConsultationReservation";
import ConsultationReservationStep from "./pages/reservation/ConsultationReservationStep";

import Check from "./pages/Check";
import SelfStart from "./pages/check/SelfStart";
import CheckStep from "./pages/check/CheckStep";
import SelfScore from "./pages/check/SelfScore";
import SelfScoreSimple from "./pages/check/SelfScoreSimple";
import SelfCheckList from "./pages/check/SelfCheckList";
import Counsel from "./pages/check/Counsel";
import CreateCounsel from "./pages/check/CreateCounsel";


import Care from "./pages/Care";
import CareStep from "./pages/care/CareStep";
import CareMenu from "./pages/care/CareMenu";
import CareSports from "./pages/care/CareSports";

import HealthNews from "./pages/News/HealthNews";

import History from "./pages/History";
import HistoryBurnKcal from "./pages/History/HistoryBurnKcal";
import HistoryEatFood from "./pages/History/HistoryEatFood";
import HistoryDrinkWater from "./pages/History/HistoryDrinkWater";
import HistoryWalking from "./pages/History/HistoryWalking";


import MoreMenu from "./pages/MoreMenu";

import Notice from "./pages/Notice/Notice";
import Support from "./pages/Notice/Support";


import Terms from "./pages/Policy/Terms";
import Private from "./pages/Policy/Private";
import UsePolicy from "./pages/Policy/UsePolicy";

import Version from "./pages/Version/Version";

import MyPage from "./pages/MyPage/MyPage";
import ReservationView from "./pages/MyPage/ReservationView";
import ScrollToTop from "./pages/ScrollToTop";
import Encyclopedia from "./pages/Encyclopedia";
import Stress from "./pages/survey/stress/Stress";
import Hra from "./pages/survey/hra/Hra";
import ComparisonHospital from "./pages/ComparisonHospital";
import Information from "./pages/Information";
import CustomerServiceFaq from "./pages/CustomerServiceFaq";
import StressMain from "./pages/survey/stress/StressMain";
import StressAnswer from "./pages/survey/stress/StressAnswer";
import StressResult from "./pages/survey/stress/StressResult";
import HraAnswer from "./pages/survey/hra/HraAnswer";
import HraResult from "./pages/survey/hra/HraResult";


import HealthResult from "./pages/MyPage/HealthResult";
import HealthMResult from "./pages/MyPage/HealthMResult";
import HealthResultCompare from "./pages/MyPage/HealthResultCompare";
import EncyclopediaDetail from "./pages/EncyclopediaDetail";
import ReservationBeforeView from "./pages/MyPage/ReservationBeforeView";
import Collect from "./pages/Policy/Collect";
import Third from "./pages/Policy/Third";
import Ads from "./pages/Policy/Ads";
import Event from "./pages/Notice/Event";


const App = () => {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/reservation" element={<Reservation />} />
        <Route path="/ConsultationReservation" element={<ConsultationReservation />} />
        <Route path="/reservation/ReservationStep" element={<ReservationStep />} />
        <Route path="/reservation/ConsultationReservationStep" element={<ConsultationReservationStep />} />
        <Route path="/reservation/SetFinishDetail" element={<SetFinishDetail />} />
        <Route path="/reservation/SetPayValidation" element={<SetPayValidation />} />
        <Route path="/stress" element={<Stress />} />
        <Route path="/stress/main" element={<StressMain />} />
        <Route path="/stress/answer" element={<StressAnswer />} />
        <Route path="/stress/result" element={<StressResult />} />

        <Route path="/check" element={<Check />} />
        <Route path="/check/SelfStart" element={<SelfStart />} />
        <Route path="/check/CheckStep" element={<CheckStep />} />
        <Route path="/check/SelfScore" element={<SelfScore />} />
        <Route path="/check/SelfScoreSimple" element={<SelfScoreSimple />} />
        <Route path="/check/SelfCheckList" element={<SelfCheckList />} />

        <Route path="/MyPage/ReservationView" element={<ReservationView />} />
        <Route path="/MyPage/ReservationBeforeView" element={<ReservationBeforeView />} />
        <Route path="/MyPage/HealthResult" element={<HealthResult />} />
        <Route path="/MyPage/HealthMResult" element={<HealthMResult />} />
        <Route path="/MyPage/HealthResultCompare" element={<HealthResultCompare />} />

        <Route path="/hra" element={<Hra />} />
        <Route path="/hra/answer" element={<HraAnswer />} />
        <Route path="/hra/result" element={<HraResult />} />

        <Route path="/check/Counsel" element={<Counsel />} />
        <Route path="/check/CreateCounsel" element={<CreateCounsel />} />

        <Route path="/care" element={<Care />} />
        <Route path="/care/careStep" element={<CareStep />} />
        <Route path="/care/CareMenu" element={<CareMenu />} />
        <Route path="/care/CareSports" element={<CareSports />} />
        <Route path="/encyclopedia" element={<Encyclopedia />} />
        <Route path="/encyclopedia/encyclopediaDetail" element={<EncyclopediaDetail />} />

        <Route path="/comparisonHospital" element={<ComparisonHospital />} />
        <Route path="/Information" element={<Information />} />

        <Route path="/CustomerServiceFaq" element={<CustomerServiceFaq />} />

        <Route path="/News/HealthNews" element={<HealthNews />} />

        <Route path="/history" element={<History />} />
        <Route path="/history/burn" element={<HistoryBurnKcal />} />
        <Route path="/history/eat" element={<HistoryEatFood />} />
        <Route path="/history/drink" element={<HistoryDrinkWater />} />
        <Route path="/history/walking" element={<HistoryWalking />} />

        <Route path="/MoreMenu" element={<MoreMenu />} />

        <Route path="/Notice/Notice" element={<Notice />} />
        <Route path="/Event" element={<Event />} />
        <Route path="/Notice/Support" element={<Support />} />

        <Route path="/Policy/Terms" element={<Terms />} />
        <Route path="/Policy/Private" element={<Private />} />
        <Route path="/Policy/UsePolicy" element={<UsePolicy />} />
        <Route path="/Policy/Collect" element={<Collect />} />
        <Route path="/Policy/Third" element={<Third />} />
        <Route path="/Policy/Ads" element={<Ads />} />

        <Route path="/Version/Version" element={<Version />} />

        <Route path="/MyPage/MyPage" element={<MyPage />} />
        <Route path="/MyPage/ReservationView" element={<ReservationView />} />


        <Route path="/login" element={<Login />} />
        <Route path="/Join/Join" element={<Join />} />
        <Route path="/Join/OfficeJoin/redirect/GET" element={<OfficeJoin />} />
        <Route path="/Join/UserJoin/redirect/GET" element={<UserJoin />} />
        <Route path="/Join/UserJoinPhysical" element={<UserJoinPhysical />} />
        <Route path="/Join/FindId" element={<FindId />} />
        <Route path="/Join/FindPassword" element={<FindPassword />} />
        <Route path="/Join/JoinAgree" element={<JoinAgree />} />
        <Route path="/Join/JoinAgreePop" element={<JoinAgree />} />
      </Routes>
    </Router>
  );
}
export default App;